import { EntityType, IUser, IBuyButtonEventExtraProps } from "../redux/types/common";
import { getEsiaProfileFields } from "./esia";
import { getConfig } from "../../../config/config";

interface IProps {
  entityType: EntityType;
  entityId: number;
  defaultDate: number;
  user?: IUser;
  eventExtraProps?: IBuyButtonEventExtraProps;
}

type WidgetEntityTypes = {
  [p in EntityType]?: string;
}

const buyEntityTypesHash: WidgetEntityTypes = {
  events: 'events',
  places: 'places',
  hotels: null,
  restaurants: null,
  overviews: 'articles',
  routes: null,
  streams: null,
  ticketsbundles: 'ticketsbundles',
  touristroutes: null,
  movies: null,
  excursions: 'excursions',
  tours: 'tours'
}

export const showBuyModal = async ({
  entityType, entityId, defaultDate = undefined, user, eventExtraProps = {},
}: IProps) => {
  const buyEntityType = buyEntityTypesHash[entityType];
  if (!buyEntityType) {
    throw new Error(`No widget support for this type "${entityType}"`);
  }
  if (!document.getElementById('buy-widget')) {
    throw new Error(`Element for widget #buy-widget not found`);
  }

  const { isBenefitZ, ...widgetEventExtraProps } = eventExtraProps;

  window['CultregSales'].showBuyWidget({
    entityType: buyEntityType,
    entityId,
    defaultDate,
    ...widgetEventExtraProps,
    ...(isBenefitZ && { isBenefitZ: true }),
    theme: getConfig().widgetTheme,
    ...user?.socials?.esia && getEsiaProfileFields(user),
  });
}
